exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../node_modules/antd/dist/antd.min.css"), "");

// module
exports.push([module.id, "*{margin:0;padding:0}#app,.container,body,html{position:relative;width:100%;height:100%;font-family:\\\\5FAE\\8F6F\\96C5\\9ED1}.content-main{top:40px;bottom:60px;right:0;overflow:auto}.content-main,.top-box{position:absolute;left:0;width:100%}.top-box{top:0;z-index:99;height:40px;background-color:#18b4ed;text-align:center;line-height:40px}.top-box .top,.top-box a{position:relative;display:block;width:100%;height:40px;color:#fff}.top-box a .anticon{left:0}.top-box .top .anticon,.top-box a .anticon{display:block;position:absolute;top:0;width:40px;height:100%}.top-box .top .anticon{right:0}.top-box .top .anticon:before,.top-box a .anticon:before{height:100%;line-height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./src/styles/app.css
// module id = 801
// module chunks = 0